// ═══════════════════════════════════════════════════════════
// DeleteModal — модалка підтвердження видалення
// Універсальний діалог з назвою елемента та попередженням
// Підтримка кастомних заголовків, повідомлень, кнопок
// ═══════════════════════════════════════════════════════════
import React, { useState, useEffect } from 'react';
import { useT } from '../contexts/I18nContext';

function DeleteModal({
  title,
  message,
  itemName,
  customerName,   // legacy alias
  onConfirm,
  onClose,
  confirmLabel,
  hideCancel,
  warning,
}) {
  const { t } = useT();
  const displayTitle = title || t('delete.title');
  const displayMessage = message || t('delete.message');
  const displayItem = itemName ?? customerName;
  const [deleting, setDeleting] = useState(false);
  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return (
    <div className="modal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal modal-sm" role="alertdialog" aria-modal="true">
        <div className="modal-header">
          <h2>{displayTitle}</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="delete-modal-body">
          <div className="delete-icon-wrap">
            <div className="delete-icon-circle">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"></path>
                <path d="M10 11v6M14 11v6"></path>
                <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"></path>
              </svg>
            </div>
          </div>
          <h3 className="delete-title">{displayTitle}</h3>
          <p className="delete-desc">{displayMessage}</p>
          {displayItem && (
            <div className="delete-name-box">{displayItem}</div>
          )}
          <p className="delete-warning">
            {warning || t('delete.warning')}
          </p>
        </div>
        <div className="modal-footer">
          {!hideCancel && (
            <button className="btn btn-secondary" onClick={onClose}>
              {t('common.cancel')}
            </button>
          )}
          <button
            className={`btn ${hideCancel ? 'btn-secondary' : 'btn-danger'}${deleting ? ' btn-loading' : ''}`}
            disabled={deleting}
            onClick={async () => {
              setDeleting(true);
              try { await onConfirm(); } finally { setDeleting(false); }
            }}
          >
            {confirmLabel || t('delete.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteModal;
